module.exports = __webpack_public_path__ + "videos/tiktok_mobile.718bc57.mp4";